//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

    import { applyMask, replaceToCyrilic } from "./helpers/Field.js"

    export default {
        props : [
          'value',
          'name',
          'label',
          'type',
          'maxlength',
          'mask',
          'autocompleteData',
          'isCyrilic',
          'isCyrilicIssued',
          'isCyrilicPlace',
          'isMoney', // Говорит о разделении разрядов пробелом в значении доходов
          'isHouse',
          'isDisabled',
          'attr-id',
          'redBorder',
          'attrs',
          'fetchLength',
          'isFocused',
          'isSilent',
          'duplicateInput',
          'isSingleSpaced',
          'tooltip',
          'cyrilicAutoReplacement',
            'placeholderText',
            'hasBackground',
            'hint',
            'isDelete',
            'isDictionary',
            'isSMS',
            'isBlured',
            'error'
        ],
        created() {
          if (this.value) {
            this.inputValue = this.value;
          }

          if (this.maxlength) {
            this.maxlengthValue = this.maxlength;
          }

          if (this.mask) {
            this.maxlengthValue = this.mask.length;
            this.maskPlaceholder = this.mask.replace(/0/g , '_');
          }

          this.isDuplicated = !!this.duplicateInput;

          if (this.autocompleteData) {
            this.isAutocompleteShown = 
              this.autocompleteData.length > 0
              && this.$refs.input == document.activeElement;
          }
          if ( this.isFocused && !this.isDisabled ) {
              this.$nextTick( () => {
                this.$refs.input.focus();
                  this.focused=true;
              });
          }

        },
        data() {
            return {
              isDuplicated: false,

              fieldValue: '',
              inputValue: '',
              placeholder: null,
              maskPlaceholder: '',

              maxlengthValue: null,
              wasBlured: false,
                focused: false,

              isAutocompleteShown : false,
              isAutocompleteClicked : false,
              timeoutedAutocomplete: false,

              // tooltipText: '',

              keyboardLayout: false,
              
            }
        },
        watch: {
            value: function (val, oldVal) {
                this.inputValue = val;
                if(val){

                }
            },
            inputValue: function (val, oldVal) {
              // if (debug) console.log('< inputValue >', val, this.keyboardLayout);
              this.prepareInputValue(val, oldVal);
              
              if ( !this.silent ) {
                this.setAutocomplete(val);
              } else {
                this.isAutocompleteShown = false;
              }

              this.inputEvent();

            },
            filteredData: function (val, oldVal) {
              if (val.length < 1 && !this.isDuplicated){
                this.isAutocompleteShown = false;
              }
            },
            mask(val) {
              this.maskPlaceholder = val.replace(/0/g , '_');
            },
            isFocused:function(val){
                if ( this.isFocused && !this.isDisabled ) {
                    this.$nextTick( () => {
                        this.$refs.input.focus();
                        this.focused=true;
                    });
                }
            },
            isBlured:function(val){
                if ( this.isBlured && !this.isDisabled ) {
                    this.$nextTick( () => {
                        this.$refs.input.blur();
                    });
                }
            }
            // tooltip( val ) {
            //   if (debug) console.log('tooltip', val);
            //   this.tooltipText = val;
            // }
        },
        computed: {
            silent() {
              return this.isSilent;
            },
            filteredData() {
              var data = this.autocompleteData;
              
              if (data) {
                if (!!this.duplicateInput && data.length > 0) {
                  this.isDuplicated = data.filter( item => 
                    item.value.toLowerCase() == this.inputValue.toLowerCase()
                    ).length == 0;
                }
                return data;
              } else {
                return [];     
              }
            },
            charactersCountBeforeFetch() {
              if (!this.fetchLength) {
                return 2;
              } else {
                return this.fetchLength;
              }
            },
            inputClasses() {
              return {
                // 'cyrilic': this.isCyrilic,
                // 'cyrilic-issued': this.isCyrilicIssued,
                // 'cyrilic-place' : this.isCyrilicPlace,
                'house': this.isHouse,
                'disabled': this.isDisabled,
                'red-border': this.redBorder,
                  'has_value': this.hasBackground,
                  'form_group_blue': this.isMts
              };
            },
            inputDisabled() {
              return this.isDisabled;
            },
            attributes() {
              return this.attrs;
            },
            tooltipText() {
              return this.tooltip;
            },
            hasBackgroundColor(){
                return this.hasBackground
            },
            isMts() {
                return this.$root.$data.isMts;
            },
            hintText() {
                return this.hint;
            },
            errorText() {
                return this.error;
            },
            isInputDelete(){
                return this.isDelete
            },
            isInputDictionary(){
                return this.isDictionary
            },
            autocompleteInput(){
                if(this.isSMS){
                    return 'one-time-code';
                }
                return 'off';
            }

        },
        methods: {
          keydownEvent( e ) {
            // if (key == 37 || key == 38 || key == 39 || key == 40 || key == 37 || key == 8 || key == 46) {
            //     $(this).tooltipError('', false);
            //     return true;
            // }
            this.$emit('keydown', e);

            let layout = false;

            if ( /[а-яА-ЯёЁ]/i.test(e.key) ) {
              layout = 'ru';
            }
            if ( /[a-zA-Z]/i.test(e.key) ) {
              layout = 'en';
            }

            // if (debug) console.log(e.key, layout );
            // if ( layout == 'en' ) {
            //   this.tooltipText = 'Вы используете английскую раскладку клавиатуры';
            // } else {
            //   this.tooltipText = '';
            // }

            this.keyboardLayout = layout;

          },
          prepareInputValue( val, oldVal ) {
              let input = this.$refs.input;
              let inputValue = val;
              let selectionPosition; 
              let gap = 0;

              // console.log('this.type',this.type);
              if ( this.type != "email" ) {
                selectionPosition = input.selectionStart;
              }

              if (this.isSingleSpaced) {
                inputValue = val.replace(/\s+/g, ' ');
              }

              if ( this.cyrilicAutoReplacement && this.keyboardLayout == 'en' ) {
                  inputValue = replaceToCyrilic( val );
              }

              if ( this.isCyrilic ) {
                inputValue = inputValue.replace(/[^а-яА-ЯёЁ -]/ig, ''); 
              }

              if ( this.isCyrilicIssued ) {
                inputValue = inputValue.replace(/[^0-9А-яЁё\/\\\(\№\-\.\,\"\)\s]/ig, '');
              }

              if ( this.isCyrilicPlace ) {
                inputValue = inputValue.replace(/[^0-9А-яЁё\(\"\-\.\)\s]/ig, ''); 
              }
              
              if (this.mask) {
                inputValue = applyMask( inputValue, this.mask, this.type ).value;
              }

              if (this.isMoney) {
                // добавляем пробел для разделения разрядов (тысяч )
                inputValue = inputValue.replace(/(\d)(?=(\d{3})+([^\d]|$))/g, '$1 ');
                gap = inputValue.replace(/\S/g, '').length;
              } 
              
              if ( this.type != "email" ) {
                input.selectionStart = selectionPosition + gap;
                input.selectionEnd = selectionPosition + gap;
              }

              this.$nextTick( function() {
                if (inputValue != val) {
                  this.inputValue = inputValue;
                }

                input.focus();
              });
          },
          inputEvent() {
            this.$emit('input', this.inputValue);
            this.validate( 'input' );
          },
          
          focusEvent() {
            // if (debug) console.log('focusEvent');
            if (this.mask) {
              this.inputValue = applyMask( this.inputValue, this.mask,this.type ).value;
            }

            if (
              (this.fetchLength == 0 || this.maxlength == 0 ) 
                && !this.isAutocompleteClicked
            ) {
              this.isAutocompleteShown = true;
            }
            this.$emit('focus');
            this.placeholder = this.maskPlaceholder;
            this.focused=true;
          },
          
          focusOnInput() {
            this.$nextTick( () => {
                this.focused=true;
              this.$refs.input.focus();
            });
          },
          
          timeoutedBlurEvent() {
            // Нужно для того чтобы клик по выпадающему списку обрабатывался до blur
            setTimeout(this.blurEvent, 200);
          },
          
          blurEvent() {
            this.isAutocompleteShown = false;

            this.$emit('blur', this.inputValue);
            this.wasBlured = true;
            this.focused=false;
            this.placeholder = null;

            if (!this.isAutocompleteClicked) {
              this.validate( 'blur' );
            } else {
              this.isAutocompleteClicked = false;
            }
          },
          autocompleteClick(item) {
            this.isAutocompleteClicked = true;

            this.inputValue = item.value;
            this.$emit('input', item.value);
            this.$emit('autocomplete-clicked', item);

            this.validate( 'autocomplete-clicked' );

            // если это справочник
            if (this.fetchLength == 0) {
              this.$emit('autocomplete-fetch', this.inputValue);
            }

            //На новом тике отрисовки ставим фокус в поле инпута
            this.$nextTick( () => {
              this.$refs.input.focus();
              this.$refs.input.selectionStart = item.value.length;
              this.isAutocompleteShown = false;
            } );
          },
          
          validate( sourceEvent ) {
              if (this.isSMS) {
                  if (this.wasBlured || this.silent) {
                      this.$emit('validate', this.inputValue, sourceEvent);
                  }
              }
              else{
                  if(this.isAutocompleteShown && this.isAutocompleteClicked){
                      this.$emit('validate', this.inputValue, sourceEvent);
                  }
                  else if(!this.isAutocompleteShown){
                      this.$emit('validate', this.inputValue, sourceEvent);
                  }
              }


//            if ( this.wasBlured || this.silent ) {
//              this.$emit('validate', this.inputValue, sourceEvent);
//            }
//              if(this.isAutocompleteClicked){
//                  this.$emit('validate', this.inputValue, sourceEvent);
//              }
          },

          setAutocomplete(val) {
              if ( !this.autocompleteData ) return;

              if ( val.length >= this.charactersCountBeforeFetch 
                    && !this.isAutocompleteClicked ) {
                this.timeoutedAutocompleteFetch();
                this.isAutocompleteShown = true;
              }
              
              if ( val.length == 0 ) {
                this.isAutocompleteShown = false;
              }
          },
          timeoutedAutocompleteFetch() {
            if ( !this.timeoutedAutocomplete ) {
              this.timeoutedAutocomplete = true;
              setTimeout(() => {
                  this.$emit('autocomplete-fetch', this.inputValue);
                  this.timeoutedAutocomplete = false;
              }, 900);
            }
          },
            deleteValue(){
                if (!this.disabled){
                   this.inputValue='';
                }
            }

        }
    }
